export default "__VITE_PUBLIC_ASSET__1de67e43__"